import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';
import { IAdminProfileResponse } from '@/models/admins.model';
import AdminTableActions from '../AdminTableActions/AdminTableActions';
import { formatDate } from '@/utils';
import { DateFormats } from '@/constants/dates';
import { TGetAdminsQuery, AdminsFiltersFields } from '../../helpers/types';

type TGetAdminsTableColumns = {
  t: TFunction;
  setDeletedAdmin: (admin: IAdminProfileResponse) => void;
  onResendInvitation: (id: string) => void;
  query: TGetAdminsQuery | null;
  canManage: boolean;
};
export const getAdminsTableColumns = ({
  t,
  setDeletedAdmin,
  onResendInvitation,
  query,
  canManage,
}: TGetAdminsTableColumns): ColumnsType<IAdminProfileResponse> => [
  {
    title: t('users_list_name'),
    dataIndex: 'name',
    key: 'name',
    render: (_, record) => record.full_name,
  },

  {
    title: t('users_list_role'),
    dataIndex: 'role',
    key: 'role',
    render: (role) => (role ? t(`common:roles.${role}`) : role),
  },
  {
    title: t('users_list_region'),
    dataIndex: 'region',
    key: 'region',
    render: (_, record) => record.region?.name || '—',
  },
  {
    title: t('users_list_email'),
    dataIndex: 'email',
    key: 'email',
  },
  {
    title:
      query?.[AdminsFiltersFields.DATE_FROM] || query?.[AdminsFiltersFields.DATE_TO]
        ? `${t('users_list_join_date')} (${
            query?.[AdminsFiltersFields.DATE_FROM]
              ? formatDate(query[AdminsFiltersFields.DATE_FROM] as string, DateFormats.EUROPEAN_DEFAULT)
              : '...'
          } - ${
            query?.[AdminsFiltersFields.DATE_TO]
              ? formatDate(query[AdminsFiltersFields.DATE_TO] as string, DateFormats.EUROPEAN_DEFAULT)
              : '...'
          })`
        : t('users_list_join_date'),
    dataIndex: 'created_at',
    key: 'created_at',
    render: (date) => formatDate(date, DateFormats.EUROPEAN),
  },
  ...(canManage
    ? [
        {
          title: t('users_list_actions'),
          key: 'actions',
          render: (_: unknown, record: IAdminProfileResponse) => (
            <AdminTableActions
              id={record.id}
              setDeletedAdmin={setDeletedAdmin}
              onResendInvitation={onResendInvitation}
              record={record}
            />
          ),
        },
      ]
    : []),
];
